module.exports = __webpack_public_path__ + "08c20a487911694291bd8c5de41315ad.ttf";